'use strict';

var AirlineColorSerivice = function AirlineColorSerivice() {
  var airlineColors = {};
  var airlineColorPalete = ['#ABDED4', '#D0ABDE', '#F0A328', '#79CAF2', '#81C341', '#00ADEF', '#FFD400', '#C5D92D'];
  var airlineColorPaleteIdx = 0;
  function getColorForAirline(airlineCode) {
    var airlineColor = airlineColors[airlineCode];
    if (airlineColor) {
      return airlineColor;
    }
    var newColor = airlineColorPalete[airlineColorPaleteIdx];
    airlineColors[airlineCode] = newColor;
    airlineColorPaleteIdx = ++airlineColorPaleteIdx % airlineColorPalete.length;
    return newColor;
  }
  return {
    getColorForAirline: getColorForAirline
  };
};
AirlineColorSerivice.$inject = [];
module.exports = AirlineColorSerivice;